/* eslint consistent-return: "warn"*/
// actions.js
//
// The middleware to call the API
import { CALL_API } from "../middleware/api";
import JWT from "../modules/getjwtdata";
import formatText from "../modules/text-helpers";
import * as types from "../types";
import server from "../config";
import store from "../modules/store";

function requestLogin() {
  return {
    type: types.LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    localData: {},
    errors: []
  };
}

export function setFirstLogin() {
  console.log("set first login");
  return {
    type: types.HAS_LOGGED_IN,
    hasLoggedIn: true
  };
}

function receiveLogin(payload, remember) {
  const user = JWT.decode(payload);
  const localData = store.get(user.id);
  return {
    type: types.LOGIN_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    user,
    localData,
    rememberUser: remember
  };
}

export function refreshLogin(payload) {
  const user = JWT.decode(payload);
  return {
    type: types.LOGIN_REFRESH,
    user
  };
}

function loginError(errors) {
  return {
    type: types.LOGIN_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    errors
  };
}

// Calls the API to get a token and
// dispatches actions along the way
export function loginUser(creds) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(creds)
  };

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestLogin(creds));

    return fetch(`${server}/login`, config)
      .then(response =>
        response.json().then(payload => ({
          payload,
          response
        }))
      )
      .then(({ payload, response }) => {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(loginError(payload.errors));
          return;
        }
        // If login was successful, set the token in local storage
        if (creds.remember) {
          localStorage.setItem("token", payload);
        } else {
          localStorage.removeItem("token"); // Prevents a scenario where the persistent token remains in storage after user logs in using sessionStorage
          sessionStorage.setItem("token", payload);
        }
        // Dispatch the success action
        dispatch(receiveLogin(payload, creds.remember));
      })
      .catch(err => dispatch(loginError({ errors: [err] })));
  };
}

function requestRegistration() {
  return {
    type: types.REGISTRATION_REQUEST,
    isFetching: true
  };
}

function receiveRegistration() {
  return {
    type: types.REGISTRATION_SUCCESS,
    isFetching: false,
    isRegistered: true
  };
}

function registrationError(message) {
  return {
    type: types.REGISTRATION_FAILURE,
    isFetching: false,
    isRegistered: false,
    message
  };
}

// Calls the API to get a token and
// dispatches actions along the way
export function registerUser(creds) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(creds)
  };

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestRegistration(creds));

    return fetch(`${server}/register`, config)
      .then(response =>
        response.json().then(data => ({
          data,
          response
        }))
      )
      .then(({ data, response }) => {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(registrationError(data.errors));
          return;
        }
        // If login was successful, set the token in local storage
        sessionStorage.setItem("token", data);
        // Dispatch the success action
        dispatch(receiveRegistration(data));
        dispatch(receiveLogin(data));
      })
      .catch(err => dispatch(registrationError({ errors: [err] })));
  };
}

export function joinGroup(body) {
  return {
    [CALL_API]: {
      endpoint: "/account/join-group",
      method: "POST",
      body,
      authenticated: true,
      types: [
        types.JOIN_GROUP_REQUEST,
        types.JOIN_GROUP_SUCCESS,
        types.JOIN_GROUP_FAILURE
      ]
    }
  };
}

function requestSingleRegistration() {
  return {
    type: types.SINGLE_REGISTRATION_REQUEST,
    isFetching: true,
    token: null
  };
}

function receiveSingleRegistration(data) {
  return {
    type: types.SINGLE_REGISTRATION_SUCCESS,
    isFetching: false,
    isRegistered: true,
    token: data
  };
}

function singleRegistrationError(errors) {
  return {
    type: types.SINGLE_REGISTRATION_FAILURE,
    isFetching: false,
    isRegistered: false,
    token: null,
    errors
  };
}

// Calls the API to get a token and
// dispatches actions along the way
export function registerSingleUser(creds) {
  /*
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(creds),
  };

  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestSingleRegistration(creds));

    return fetch(`${server}/register-free-trial`, config)
      .then(response =>
        response.json()
        .then(data => ({
          data,
          response,
        })),
      )
      .then(({
        data,
        response,
      }) => {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(singleRegistrationError(data.errors));
          //return Promise.reject(data.errors);
        } else {
          // If login was successful, set the token in local storage
          if (creds.remember) {
            localStorage.setItem('token', data);
          } else {
            localStorage.removeItem('token'); // Prevents a scenario where the persistent token remains in storage after user logs in using sessionStorage
            sessionStorage.setItem('token', data);
          }
        dispatch(receiveSingleRegistration(data));

        // Wait for login, this gives time to prepare the user for the transition in the UI
        setTimeout(() => {
          dispatch(receiveLogin(data,creds.remember));
        }, 3000)
        }
      })
      .catch(err => dispatch(singleRegistrationError(err)) );
  };
  */
}

function requestSingleFreeRegistration() {
  return {
    type: types.SINGLE_FREE_REGISTRATION_REQUEST,
    isFetching: true,
    token: null
  };
}

function receiveSingleFreeRegistration(data) {
  return {
    type: types.SINGLE_FREE_REGISTRATION_SUCCESS,
    isFetching: false,
    isRegistered: true,
    token: data
  };
}

function singleFreeRegistrationError(errors) {
  return {
    type: types.SINGLE_FREE_REGISTRATION_FAILURE,
    isFetching: false,
    isRegistered: false,
    token: null,
    errors
  };
}

// Calls the API to get a token and
// dispatches actions along the way
export function registerSingleFreeUser(creds) {
  /*
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(creds),
  };

  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestSingleFreeRegistration(creds));

    return fetch(`${server}/register-free`, config)
      .then(response =>
        response.json()
        .then(data => ({
          data,
          response,
        })),
      )
      .then(({
        data,
        response,
      }) => {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(singleFreeRegistrationError(data.errors));
          //return Promise.reject(data.errors);
        } else {
          // If login was successful, set the token in local storage
          if (creds.remember) {
            localStorage.setItem('token', data);
          } else {
            localStorage.removeItem('token'); // Prevents a scenario where the persistent token remains in storage after user logs in using sessionStorage
            sessionStorage.setItem('token', data);
          }
        dispatch(receiveSingleFreeRegistration(data));
        }
      })
      .catch(err => dispatch(singleFreeRegistrationError(err)) );
  };*/
}

function requestTrialRegistration() {
  return {
    type: types.TRIAL_REGISTRATION_REQUEST,
    isFetching: true
  };
}

function receiveTrialRegistration() {
  return {
    type: types.TRIAL_REGISTRATION_SUCCESS,
    isFetching: false,
    isRegistered: true
  };
}

function trialRegistrationError(message) {
  return {
    type: types.TRIAL_REGISTRATION_FAILURE,
    isFetching: false,
    isRegistered: false,
    message
  };
}

export function registerTrialUser(creds) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(creds)
  };

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestTrialRegistration(creds));

    return fetch(`${server}/start-trial/register`, config)
      .then(response =>
        response.json().then(data => ({
          data,
          response
        }))
      )
      .then(({ data, response }) => {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition
          dispatch(trialRegistrationError(data));
          return;
        }
        // If login was successful, set the token in local storage
        sessionStorage.setItem("token", data);
        // Dispatch the success action
        dispatch(receiveTrialRegistration(data));
        dispatch(receiveLogin(data, false));
      })
      .catch(err => dispatch(trialRegistrationError({ errors: [err] })));
  };
}

// Three possible states for our logout process as well.
// Since we are using JWTs, we just need to remove the token
// from localStorage. These actions are more useful if we
// were calling the API to log the user out
function requestLogout() {
  return {
    type: types.LOGOUT_REQUEST,
    isFetching: true
  };
}

export function receiveLogout() {
  return {
    type: types.LOGOUT_SUCCESS,
    isFetching: false,
    isAuthenticated: false,
    user: {},
    remember: false
  };
}

function logoutError(message) {
  return {
    type: types.LOGOUT_FAILURE,
    isFetching: false,
    message,
    user: {}
  };
}

// Logs the user out
export function logoutUser() {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const headers = new Headers();
  headers.append(
    "Authorization",
    `Bearer ${token}`,
    ("Content-Type": "application/json"),
    ("Accept": "application/json")
  );

  const config = {
    method: "POST",
    headers
  };

  return dispatch => {
    dispatch(requestLogout());

    return fetch(`${server}/logout`, config)
      .then(response =>
        response.json().then(data => ({
          data,
          response
        }))
      )
      .then(({ data, response }) => {
        localStorage.removeItem("token");
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition

          dispatch(logoutError(data.errors));
          dispatch(receiveLogout());
          return;
        }
        // Dispatch the success action
        dispatch(receiveLogout());
      })
      .catch(err => dispatch(logoutError({ errors: [err] })));
  };
}

export function validateTrialToken(body) {
  return {
    [CALL_API]: {
      endpoint: "/start-trial/validate",
      method: "POST",
      body,
      authenticated: false,
      types: [
        types.VALIDATE_TRIAL_TOKEN_REQUEST,
        types.VALIDATE_TRIAL_TOKEN_SUCCESS,
        types.VALIDATE_TRIAL_TOKEN_FAILURE
      ]
    }
  };
}

// Password Reset
/*
function requestPasswordEmail(email) {
  return {
    type: types.PASSWORD_EMAIL_REQUEST,
    isFetching: true,
  };
}

function receivePasswordEmail() {
  return {
    type: types.PASSWORD_EMAIL_SUCCESS,
  };
}

function passwordEmailError(message) {
  return {
    type: types.PASSWORD_EMAIL_FAILURE,
    message,
  };
}*/

export function sendResetPasswordLink(body) {
  return {
    [CALL_API]: {
      endpoint: "/password/email",
      method: "POST",
      body,
      authenticated: false,
      types: [
        types.PASSWORD_EMAIL_REQUEST,
        types.PASSWORD_EMAIL_SUCCESS,
        types.PASSWORD_EMAIL_FAILURE
      ]
    }
  };
}

/*
function requestPasswordReset(creds) {
  return {
    type: types.PASSWORD_RESET_REQUEST,
    isFetching: true,
    hasFetched: false,
    isSuccess: false,
    creds,
  };
}

function receivePasswordReset() {
  return {
    type: types.PASSWORD_RESET_SUCCESS,
    isFetching: false,
    hasFetched: true,
    isSuccess: true,
  };
}

function passwordResetError(message) {
  return {
    type: types.PASSWORD_RESET_FAILURE,
    isFetching: false,
    hasFetched: true,
    isSuccess: false,
    message,
  };
} */

export function resetPassword(body) {
  return {
    [CALL_API]: {
      endpoint: "/password/reset",
      method: "POST",
      body,
      authenticated: false,
      types: [
        types.PASSWORD_RESET_REQUEST,
        types.PASSWORD_RESET_SUCCESS,
        types.PASSWORD_RESET_FAILURE
      ]
    }
  };
}

export function fetchExercises() {
  return {
    [CALL_API]: {
      endpoint: "/exercises",
      method: "GET",
      authenticated: true,
      types: [
        types.EXERCISE_REQUEST,
        types.EXERCISE_SUCCESS,
        types.EXERCISE_FAILURE
      ]
    }
  };
}

export function launchExercise(index) {
  return {
    type: types.LAUNCH_EXERCISE,
    activeExercise: index
  };
}

export function clearExercise() {
  return {
    type: types.CLEAR_EXERCISE,
    activeExercise: 0
  };
}

export function createExercise(body) {
  return {
    [CALL_API]: {
      endpoint: "/exercises",
      method: "POST",
      body,
      authenticated: true,
      types: [
        types.EXERCISE_CREATE_REQUEST,
        types.EXERCISE_CREATE_SUCCESS,
        types.EXERCISE_CREATE_FAILURE
      ]
    }
  };
}

export function updateExercise(id, body) {
  return {
    [CALL_API]: {
      endpoint: `/exercises/${id}`,
      method: "PUT",
      body,
      authenticated: true,
      types: [
        types.EXERCISE_UPDATE_REQUEST,
        types.EXERCISE_UPDATE_SUCCESS,
        types.EXERCISE_UPDATE_FAILURE
      ]
    }
  };
}

// Uses the API middlware to get a quote
export function deleteExercise(id) {
  return {
    [CALL_API]: {
      endpoint: `/exercises/${id}`,
      method: "DELETE",
      authenticated: true,
      types: [
        types.EXERCISE_DELETE_REQUEST,
        types.EXERCISE_DELETE_SUCCESS,
        types.EXERCISE_DELETE_FAILURE
      ]
    }
  };
}

export function downloadReport(body) {
  return {
    [CALL_API]: {
      endpoint: "/exercises/download-report",
      method: "POST",
      body,
      type: "blob",
      authenticated: true,
      types: [
        types.HISTORY_REPORT_REQUEST,
        types.HISTORY_REPORT_SUCCESS,
        types.HISTORY_REPORT_FAILURE
      ]
    }
  };
}

export function launchText(text) {
  return {
    type: types.LAUNCH_TEXT,
    activeText: 0,
    texts: formatText(text)
  };
}

export function selectText(index) {
  return {
    type: types.SELECT_TEXT,
    index
  };
}

export function clearText() {
  return {
    type: types.CLEAR_TEXT
  };
}

export function updateSource(source) {
  return {
    type: types.UPDATE_SOURCE,
    source
  };
}

export function updateTranslation(translation) {
  console.log("update translation");
  return {
    type: types.UPDATE_TRANSLATION,
    translation
  };
}

export function nextSentence() {
  return {
    type: types.NEXT_SENTENCE
  };
}

export function prevSentence() {
  return {
    type: types.PREV_SENTENCE
  };
}

export function spliceSentence() {
  return {
    type: types.SPLICE_SENTENCE
  };
}

export function setUtteranceLength(length) {
  return {
    type: types.SET_UTTERANCE_LENGTH,
    utteranceLength: length
  };
}

export function setRecording(buffer, float32ArrayBuffers) {
  return {
    type: types.SET_RECORDING,
    buffer,
    float32ArrayBuffers
  };
}

export function addResults(results) {
  return {
    type: types.ADD_RESULTS,
    results
  };
}

export function addHistory(history) {
  return {
    type: types.ADD_HISTORY,
    text: history.text,
    results: history.results,
    language: history.language
  };
}

export function changeSettings(body) {
  return {
    [CALL_API]: {
      endpoint: "/account",
      method: "POST",
      body,
      authenticated: true,
      types: [
        types.CHANGE_SETTINGS_REQUEST,
        types.CHANGE_SETTINGS_SUCCESS,
        types.CHANGE_SETTINGS_FAILURE
      ]
    }
  };
}

export function changePassword(body) {
  return {
    [CALL_API]: {
      endpoint: "/account/password",
      method: "POST",
      body,
      authenticated: true,
      types: [
        types.CHANGE_PASSWORD_REQUEST,
        types.CHANGE_PASSWORD_SUCCESS,
        types.CHANGE_PASSWORD_FAILURE
      ]
    }
  };
}

export function validateToken(body) {
  return {
    [CALL_API]: {
      endpoint: "/validate/token",
      method: "POST",
      body,
      authenticated: false,
      types: [
        types.VALIDATE_TOKEN_REQUEST,
        types.VALIDATE_TOKEN_SUCCESS,
        types.VALIDATE_TOKEN_FAILURE
      ]
    }
  };
}

export function validateEmail(body) {
  return {
    [CALL_API]: {
      endpoint: "/validate/email",
      method: "POST",
      body,
      authenticated: false,
      types: [
        types.VALIDATE_EMAIL_REQUEST,
        types.VALIDATE_EMAIL_SUCCESS,
        types.VALIDATE_EMAIL_FAILURE
      ]
    }
  };
}

export function fetchGroup() {
  return {
    [CALL_API]: {
      endpoint: "/group-settings",
      method: "GET",
      authenticated: true,
      types: [types.GROUP_REQUEST, types.GROUP_SUCCESS, types.GROUP_FAILURE]
    }
  };
}

export function updateGroup(body) {
  return {
    [CALL_API]: {
      endpoint: "/group-settings",
      method: "PUT",
      body,
      authenticated: true,
      types: [
        types.GROUP_UPDATE_REQUEST,
        types.GROUP_UPDATE_SUCCESS,
        types.GROUP_UPDATE_FAILURE
      ]
    }
  };
}

export function generateToken() {
  return {
    [CALL_API]: {
      endpoint: "/group-settings/generatetoken",
      method: "POST",
      authenticated: true,
      types: [
        types.GROUP_TOKEN_REFRESH_REQUEST,
        types.GROUP_TOKEN_REFRESH_SUCCESS,
        types.GROUP_TOKEN_REFRESH_FAILURE
      ]
    }
  };
}

export function fetchGroupUsers() {
  return {
    [CALL_API]: {
      endpoint: "/group-settings/users",
      method: "GET",
      authenticated: true,
      types: [
        types.GROUP_USERS_REQUEST,
        types.GROUP_USERS_SUCCESS,
        types.GROUP_USERS_FAILURE
      ]
    }
  };
}

export function updateUser(id, body) {
  return {
    [CALL_API]: {
      endpoint: `/group-settings/users/${id}`,
      method: "PUT",
      body,
      authenticated: true,
      types: [
        types.GROUP_USER_UPDATE_REQUEST,
        types.GROUP_USER_UPDATE_SUCCESS,
        types.GROUP_USER_UPDATE_FAILURE
      ]
    }
  };
}

export function removeUser(id) {
  return {
    [CALL_API]: {
      endpoint: `/group-settings/users/${id}`,
      method: "DELETE",
      authenticated: true,
      types: [
        types.GROUP_USER_REMOVE_REQUEST,
        types.GROUP_USER_REMOVE_SUCCESS,
        types.GROUP_USER_REMOVE_FAILURE
      ]
    }
  };
}

export function sendInvitation(emails) {
  return {
    [CALL_API]: {
      endpoint: "/group-settings/sendtoken",
      method: "POST",
      body: {
        emails
      },
      authenticated: true,
      types: [
        types.GROUP_SEND_INVITATION_REQUEST,
        types.GROUP_SEND_INVITATION_SUCCESS,
        types.GROUP_SEND_INVITATION_FAILURE
      ]
    }
  };
}

export function createSubscription(body) {
  return {
    [CALL_API]: {
      endpoint: "/account/subscribe",
      method: "POST",
      body,
      authenticated: true,
      types: [
        types.CREATE_SUBSCRIPTION_REQUEST,
        types.CREATE_SUBSCRIPTION_SUCCESS,
        types.CREATE_SUBSCRIPTION_FAILURE
      ]
    }
  };
}

export function updateCreditCard(body) {
  return {
    [CALL_API]: {
      endpoint: "/account/update-card",
      method: "POST",
      authenticated: true,
      body,
      types: [
        types.UPDATE_CARD_REQUEST,
        types.UPDATE_CARD_SUCCESS,
        types.UPDATE_CARD_FAILURE
      ]
    }
  };
}

export function resumeSubscription() {
  /*
  return {
    [CALL_API]: {
      endpoint: "/account/resume-subscription",
      method: "POST",
      authenticated: true,
      types: [
        types.RESUME_SUBSCRIPTION_REQUEST,
        types.RESUME_SUBSCRIPTION_SUCCESS,
        types.RESUME_SUBSCRIPTION_FAILURE
      ]
    }
  };*/
}

export function claimCoupon(body) {
  return {
    [CALL_API]: {
      endpoint: "/account/claim-coupon",
      method: "POST",
      body,
      authenticated: true,
      types: [
        types.CLAIM_COUPON_REQUEST,
        types.CLAIM_COUPON_SUCCESS,
        types.CLAIM_COUPON_FAILURE
      ]
    }
  };
}

export function getSubscriptions() {
  return {
    [CALL_API]: {
      endpoint: "/account/subscriptions",
      method: "GET",
      authenticated: true,
      types: [
        types.SUBSCRIPTIONS_REQUEST,
        types.SUBSCRIPTIONS_SUCCESS,
        types.SUBSCRIPTIONS_FAILURE
      ]
    }
  };
}

export function getPlan() {
  return {
    [CALL_API]: {
      endpoint: "/plan",
      method: "GET",
      authenticated: false,
      types: [types.PLAN_REQUEST, types.PLAN_SUCCESS, types.PLAN_FAILURE]
    }
  };
}

export function getInvoices() {
  return {
    [CALL_API]: {
      endpoint: "/account/invoices",
      method: "GET",
      authenticated: true,
      types: [
        types.INVOICES_REQUEST,
        types.INVOICES_SUCCESS,
        types.INVOICES_FAILURE
      ]
    }
  };
}

export function cancelSubscription() {
  return {
    [CALL_API]: {
      endpoint: "/account/subscription",
      method: "DELETE",
      authenticated: true,
      types: [
        types.CANCEL_SUBSCRIPTION_REQUEST,
        types.CANCEL_SUBSCRIPTION_SUCCESS,
        types.CANCEL_SUBSCRIPTION_FAILURE
      ]
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/actions.js